import { EditorEntityData } from '~/editor/helpers/EditorEntityData';
import { BufferEditor } from '~/editor/BufferEditor/types.plate';
import { wrapLinkedInAnnotation } from '../transforms/wrapLinkedInAnnotation';

export const findAndWrapLinkedIndAnnotations = (
  editor: BufferEditor,
  { entities }: { entities?: EditorEntityData } = {}
) => {
  if (entities) {
    EditorEntityData.getLinkedInAnnotations(entities).forEach((annotation) => {
      wrapLinkedInAnnotation(editor, annotation);
    });
  }
};
